export default "__VITE_ASSET__7EwGs9fu__"